








































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/ts/main";

@Component({
    components: {
        CloseButton: () => import("@components/elements/CloseButton.vue")
    }
})
export default class Slideout extends Vue {
    @Prop() show!: boolean;
    @Prop({ default: true }) showClose!: boolean;

    $refs!: Vue["$refs"] & {
        slideout: HTMLElement;
    };

    @Watch("show")
    onVisibleChange(show: boolean) {
        if (show === true) {
            this.$refs.slideout.focus();
        } else {
            bus.$emit("hamburger-close");
        }
    }
}
